
<template>
<body id="page-top" class="member-page-body">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio" id="portfolio">
            <div class="container">
              <div>    
                       <div class="mb-3 row" v-if="step === 0">
                         <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">Select Case No.</label>
                            <div class="col-sm-10">
                              <input :disabled="LOAlist.length == 0" readonly autocomplete="off" placeholder="Tap here to select a LOA to print." style="width:90%;" v-b-modal.modal-center v-model="CaseNo" class="form-control" id="exampleFormControlTextarea1" type="search" aria-label="Search" required>
                            </div>
                            <div>
                        <!--<b-button style="float:right; margin-top:25px;" v-b-modal.modal-center type="button" class="btn btn-primary btn-lg">SEARCH</b-button>-->
                        

                        <b-modal id="modal-center" centered class="preview-modal" ref="preview-modal">
                            <div>
                            <a v-if="LOAlist.length == 0" style="font-size:30px;"></a>
                            <a v-else-if="LOAlist.length != 0" href="#" class="list-group-item list-group-item-action" v-for="item in LOAlist" :key="item.CaseNo" @click="preview(item)">
                            {{item.CaseNo}}<br>
                            {{item.DateCreated}}<br>
                            {{item.ServiceType}}
                          </a>
                            </div>
                        </b-modal>
      <!-- EMAIL LOA -->
      <b-modal 
        id="modal-prevent-closing"
        ref="modal"
        title="Send LOA to your email address"
        ok-title-html="Send"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk" 
      >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Verify your email"
          label-for="name-input"
        >
          <b-form-input
            id="name-input"
            v-model="previewEmail"
            type="email"
            :state="emailState"
            @input="validateEmail"
            required
          ></b-form-input>
        <b-form-invalid-feedback id="email-error">
          {{ previewEmailFeedback }}
        </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          label="Retype your email"
          label-for="email-verify-input"
        >
          <b-form-input
            id="name-input"
            v-model="verifyPreviewEmail"
            type="email"
            :state="verifyEmailState"
            @input="validateVerifyEmail"
           
            required
          ></b-form-input>
          <b-form-invalid-feedback id="email-error">
          {{ verifyEmailFeedback }}
        </b-form-invalid-feedback>
        </b-form-group>
      </form>
    </b-modal>

     <!-- Modal -->
     <b-modal id="email-sent-modal" centered class="email-sent-modal" ref="email-sent-modal">
    
        
          <p>{{ emailMessageReturn }}</p>
        
     </b-modal>
    <!-- END EMAIL LOA -->
                 
                        </div>
                       </div>
              </div>

              <div v-if="step === 1 && showSurveyForm">
                <div class="row justify-content-center survey-form">
                  <SurveyForm @submit="handleFormSubmit" @closesurveyform="closeSurveyForm" />
                </div>
              </div>

                <div v-if="!showSurveyForm" class="row justify-content-center loa-form">
                    <div class="login-form">
                        <div v-if="step === 0">
                          <div v-if="LOAlist.length == 0">  
                            <p class="no-records-error">No records found.</p>
                          </div>
                          <div v-if="LOAlist.length > 0">  
                            <iframe :src="LOAurl" crossorigin="anonymous" id="loaprint" ref="loaprint"></iframe>
                         </div>
                        </div>
                       
                        <div v-if="step === 1">
                          <p class="lead custom-notice option-notice">
                                  Do you have other transactions?
                                  <router-link to="/member-page"><button class="btn btn-primary btn-lg yes-no-option">YES</button></router-link>
                                  <button class="btn btn-primary btn-lg yes-no-option" @click='logOut'>NO</button>
                          </p>
                       </div>

                    </div>
                    
                  <div id="print-hidden" class="col-md-12" style="padding-top: 25px;">
                  <button @click="print()" type="button" style="margin-right: 10px;" class="btn btn-primary btn-lg" :disabled="step == 1 || LOAlist.length == 0" >PRINT</button>
                  <!--<router-link to="/member-page"><a type="button" style="margin-left: 10px;" class="btn btn-primary btn-lg">CANCEL</a></router-link>-->
                  <b-button v-b-modal.modal-prevent-closing class="btn btn-secondary btn-lg email-pdf" :disabled="step == 1 || LOAlist.length == 0" >EMAIL LOA</b-button>
                  <button @click="nextStep" class="btn btn-primary btn-lg" :disabled="step == 1">NEXT</button>
            </div>
                </div>
        </div>
        </section>
</body>
</template>


<script>
import SurveyForm from "@/components/Survey.vue";
import axios from 'axios';
export default {
  name: 'DoctorName',
  data() {
    return {
      certNo: '',
      TokenID: '',
      LastName: '',
      FirstName: '',
      Doctors: [],
      LOAurl:'',
      LOAlist:[],
      CaseNo:'',
      LOATokenID: '',
      step: 0,
      previewEmail : '',
      verifyPreviewEmail : '',
      verifyEmailState : null,
      emailState : null,
      showSurveyForm : false,
      Facility: '',
      emailMessageReturn: ''
    }
  },
  /*created() {
      console.log(localStorage.key(0));
      if (localStorage.getItem('CertNo') === null) {
          this.$router.push('/login');
      }
      if (localStorage.getItem('CertNo') ) {
          this.CertNo = localStorage.getItem('CertNo')
          this.LOAurl = 'https://apps.philcare.com.ph/ITGPortal/ViewCurrentKioskLOA.aspx?CertNo='+this.CertNo;
          //this.LOAurl = 'https://apps.philcare.com.ph/ITGPortalTest/ViewCurrentKioskLOA.aspx?CertNo='+this.CertNo;
      }
    },*/

  async created() {
      this.loading = true
      this.certNo = localStorage.getItem('CertNo')
      const response = await axios.post('/api/?action=get-member-util', {
          CertNo: this.certNo
      }, 
      );

      
        console.log('RESPONSE', response);
        this.loading = false
        if (localStorage.getItem('CertNo') === null) {
          this.$router.push('/login');
        }

        //this.PlanBenefitsHTML=response.data.PlanBenefitsHTML;
        //this.ProviderAccessHTML=response.data.ProviderAccessHTML;
        //this.StatusHTML=response.data.StatusHTML;
        this.LOAlist=response.data;
        //this.LOAlist = response.data.sort((a, b) => new Date(b.DateCreated) - new Date(a.DateCreated));
        this.CaseNo=response.data[0].CaseNo;
        this.LOATokenID=response.data[0].LOATokenID; 
        this.Facility=response.data[0].ServiceType;
        const response2 = await axios.post('/api/?action=save-loa-preview', {
           CaseNo: this.CaseNo,
           LOATokenID: this.LOATokenID
        }, 
        );
        console.log(response2);
        //this.LOAurl = 'https://apps.philcare.com.ph//ITGPortalTest//GenerateLOA.aspx?CaseNo='+response.data[0].CaseNo;
        this.LOAurl = response2.data.loaURL+"#toolbar=0";
        //this.LOAurl = response.data.loaURL+"#toolbar=0";
    },

  methods: {
    async preview(item) {
      const response = await axios.post('/api/?action=save-loa-preview', {
           CaseNo: item.CaseNo,
           LOATokenID: item.LOATokenID,
        });
        this.LOAurl =  response.data.loaURL+"#toolbar=0";
        this.CaseNo=item.CaseNo;
        this.Facility=item.ServiceType;
        this.hideModal()
    },
    hideModal() {
            this.$refs['preview-modal'].hide();
            },
    print() {
    var iframe = document.getElementById("loaprint")
    iframe.contentWindow.focus();       
    iframe.contentWindow.print(); 
    },
    emailPDF() {
      this.$refs['email-modal'].show();
    },  
    nextStep(){
      this.step = this.step+1
      if (this.step == 1) {
        this.showSurveyForm = true;
      }
    },
    validateEmail() {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (emailPattern.test(this.previewEmail)) {
      this.emailState = true; // Valid email
      this.previewEmailFeedback = '';
    } else {
      this.emailState = false; // Invalid email
      this.previewEmailFeedback = 'Please enter a valid email address.';
    }
  },
  validateVerifyEmail() {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (emailPattern.test(this.verifyPreviewEmail)) {
      this.verifyEmailState = true; // Valid email
      this.verifyEmailFeedback = '';
    } else {
      this.verifyEmailState = false; // Invalid email
      this.verifyEmailFeedback = 'Please enter a valid email address.';
    }
  },
  resetModal() {
    this.verifyPreviewEmail = ''
    this.previewEmail = ''
    this.verifyEmailState = null
  },
  handleOk(bvModalEvent) {
    bvModalEvent.preventDefault()
    this.handleSubmit()
  },

  async handleSubmit() {
    this.emailState = true;
    if (this.previewEmail == '') {
      this.emailState = false; // Invalid email
      this.previewEmailFeedback = 'Please enter a valid email address.';
    }

    if (this.verifyPreviewEmail == '') {
      this.verifyEmailState = false;  // Invalid email
      this.emailState = false; 
      this.verifyEmailFeedback = 'Please enter a valid email address.';
    }

    if (this.verifyPreviewEmail != this.previewEmail ) {
      this.verifyEmailState = false; 
      this.emailState = false; // Invalid email
      this.verifyEmailFeedback = "Email addresses don't match";
    }

    if (!this.emailState) { 
      return
    } 

   
    this.certNo = localStorage.getItem('CertNo');
    const response = await axios.post('/api/?action=email-loa-pdf', {
       Email : this.previewEmail,
       CaseNo: this.CaseNo
    }) 

    if (response.data[0].SuccessFlag == "1") {
      this.$bvModal.hide('modal-prevent-closing')
      this.$refs['email-sent-modal'].show();
      this.emailMessageReturn = 'LOA form has been successfully sent to your email!';
    }

   // this.emailMessageReturn = response.data.MessageReturn

    console.log(response)

    
  },
  logOut() {
      localStorage.removeItem('CertNo');
      localStorage.removeItem('allowLOAConsult');
      localStorage.removeItem('allowLOALab');
      this.$router.push('/login');

  },
 
  async handleFormSubmit(answers) {
    console.log("Submitted answers:", answers);
    this.certNo = localStorage.getItem('CertNo');
    const response = await axios.post('/api/?action=submit-survey', {
       Answers : answers,
       Facility : this.Facility,
       CertNo: this.certNo,
       CaseNo: this.CaseNo
    }) 

    console.log(response)
  },

  closeSurveyForm(closeform) {
    this.showSurveyForm = closeform;
  }

  },
  components: {
  SurveyForm
  }
}
</script>
<style>
.modal-content {
  height: 50%;
}

.modal-dialog.modal-xl {
  margin-top: 20%;
}

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
